import { LitElement, html } from '@hh/global.js';

class HHBroadcast extends LitElement {
  static properties = {
    on: {},
    event: {},
    data: {},
  };

  constructor() {
    super();
    this.method = 'document';
    this.on = 'click';
    // Bind the handleKeydown method to the instance of this class
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    // Add event listeners
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Remove event listeners
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('click', this.onClick);
  }

  handleKeydown(event) {
    // Check if Enter or Space is pressed
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent the default action
      this.onClick(event); // Trigger the click logic
    }
  }

  onClick(event) {
    // Logic to execute on click or when activated by keyboard
    if (this.method === 'document') {
      document.body.setAttribute(this.event, this.data);
    }
    // Optionally, you can dispatch a custom event here
  }

  render() {
    return html`<slot @click="${this.onClick}" tabindex="0"></slot>`
  }
}

customElements.define('hh-broadcast', HHBroadcast);
